/**
 * Created by ivan on 11.04.18.
 */

const TravelBookToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.TRAVEL_BOOK);

    this.enable();
};

TravelBookToolbarItem.prototype = Object.create(ToolbarItem.prototype);
TravelBookToolbarItem.prototype.constructor = TravelBookToolbarItem;

TravelBookToolbarItem.prototype.resetState = function () {
    if (cleverapps.travelBook.needsAttention()) {
        this.mark();
    } else {
        this.unmark();
    }
};

TravelBookToolbarItem.prototype.getForce = function () {
    return cleverapps.travelBook.chooseForce();
};

TravelBookToolbarItem.prototype.isVisible = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.TRAVEL_BOOK);
};

TravelBookToolbarItem.prototype.showForce = function () {
    ToolbarItem.prototype.showForce.call(this);

    cleverapps.travelBook.markForceShown();
};

TravelBookToolbarItem.prototype.onClick = function (force) {
    cleverapps.focusManager.display({
        focus: "TravelBook",
        action: function (f) {
            new TravelBookWindow({
                targetPage: force && force.page
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

Placements.ENTRIES["travelBook"] = {
    type: Placements.FREE_FOCUS,
    priority: 1,
    filter: function () {
        return cleverapps.environment.isMainScene();
    },

    action: function () {
        cleverapps.travelBook.updatePages();
        cleverapps.toolbar.resetByType(ToolbarItem.TRAVEL_BOOK);
    }
};